import fetcher from 'api/fetcher';
import { CampaignStatus } from 'utils/constants/dashboard';
import { MagritteNotificationName } from 'utils/constants/notification';

import { fetchCampaignsCount } from 'components/CampaignCard/CampaignInfo/Actions/fetchCampaignsCount';

import { setCampaignArchiveModalShow } from 'store/autoReducers';
import { setIdAdminAction, setLoadCampaignAdminAction } from 'store/models/adminCampaignAction';
import { CampaignTabStatus, setCampaigns } from 'store/models/dashboard';
import { addMagritteNotification } from 'store/models/notification';
import { AppThunkAction } from 'store/utils';

export const fetchArchiveCampaign =
    (campaignId: number): AppThunkAction =>
    (dispatch, getState) => {
        const state = getState();
        const currentStatus = state.campaignTabsStatus;
        const campaigns = state.dashboard.campaigns;
        const campaignIdx = campaigns.findIndex(({ id }) => id === campaignId);

        return fetcher
            .put(`/api/v1/backoffice/campaign/${campaignId}/archive?archiveReason=WRONG_ACCOUNT`)
            .then(() => {
                const newCampaigns = [...campaigns];
                if (currentStatus === CampaignTabStatus.Active) {
                    newCampaigns.splice(campaignIdx, 1);
                } else {
                    newCampaigns[campaignIdx] = {
                        ...newCampaigns[campaignIdx],
                        frontendStatus: CampaignStatus.Archived,
                    };
                }

                dispatch([
                    setCampaigns(newCampaigns),
                    setCampaignArchiveModalShow(false),
                    setLoadCampaignAdminAction(false),
                    setIdAdminAction(null),
                    addMagritteNotification(MagritteNotificationName.CampaignChangeStatusToArchiveSuccess),
                ]);
            })
            .then(() => dispatch(fetchCampaignsCount()))
            .catch(() => {
                dispatch(addMagritteNotification(MagritteNotificationName.CampaignArchiveError));
            });
    };
